export default function() {
  var $ = $ || jQuery

  $('.caret-toggle').click(function(e) {
    e.preventDefault;
    $(this).toggleClass('active');
    $(this).siblings('.menu-nested').slideToggle();
  });

}